export interface GopherMarkProps {
  size: '24px' | '32px' | '40px';
}

export function GopherMark({ size }: GopherMarkProps) {
  return (
    <img
      src="/gopher-avatar.png"
      alt=""
      aria-hidden="true"
      width={parseInt(size, 10)}
      height={parseInt(size, 10)}
      className="inline-block shrink-0 rounded-full"
      style={{ width: size, height: size }}
    />
  );
}
